import { ApiProperty } from '@nestjs/swagger';
import { BaseEntityResponseDto } from '@sphere/shared/domain';

export class AttemptStatusResponseDto extends BaseEntityResponseDto {
  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;
}

